{
    "name": "@dds/react",
    "author": "DellDesignSystem@Dell.com",
    "license": "MIT",
    "version": "2.5.1",
    "private": false,
    "type": "module",
    "files": [
        "library"
    ],
    "main": "./library/index.umd.cjs",
    "module": "./library/index.js",
    "exports": {
        ".": {
            "import": "./library/index.js",
            "require": "./library/index.umd.cjs",
            "types": "./library/index.d.ts"
        },
        "./css/dds-main.css": "./library/css/dds-main.css",
        "./css/dds-reboot.css": "./library/css/dds-reboot.css",
        "./css/dds-fonts.css": "./library/css/dds-fonts.css",
        "./css/dds-icons.css": "./library/css/dds-icons.css",
        "./css/dds-helpers.css": "./library/css/dds-helpers.css",
        "./css/dds-templates.css": "./library/css/dds-templates.css",
        "./css/dds-components.css": "./library/css/dds-components.css"
    },
    "scripts": {
        "dev": "vite",
        "build": "npm run build:tokens && npm run build:storybook && npm run build:app && npm run build:library",
        "build:tokens": "cd core && npm run build:tokens",
        "build:storybook": "storybook build",
        "build:app": "tsc && vite build --config vite.config.app.ts",
        "build:library": "tsc && vite build && vite build --config vite.config.styles.ts && node vite.post-build.js",
        "eslint:fix": "eslint --fix ./",
        "eslint:check": "eslint ./",
        "lint": "eslint src --ext ts,tsx --report-unused-disable-directives --max-warnings 0",
        "lint:check": "npm run eslint:check && npm run stylelint:check && npm run prettier:check",
        "lint:fix": "npm run eslint:fix && npm run stylelint:fix && npm run prettier:fix",
        "prepare": "husky install",
        "prettier:fix": "prettier -w ./",
        "prettier:check": "prettier --log-level log -c ./",
        "preview": "vite preview",
        "storybook": "storybook dev -p 6006",
        "stylelint:check": "stylelint ./**/*.scss",
        "stylelint:fix": "stylelint --fix ./**/*.scss",
        "test": "jest",
        "test:watch": "jest --watch",
        "test:coverage": "jest --coverage",
        "release:dry": "standard-version --dry-run --release-as",
        "release": "standard-version --release-as"
    },
    "dependencies": {
        "react": "^18.2.0",
        "react-dom": "^18.2.0",
        "react-router-dom": "^6.14.2"
    },
    "devDependencies": {
        "@babel/preset-env": "^7.22.7",
        "@babel/preset-react": "^7.22.5",
        "@babel/preset-typescript": "^7.22.5",
        "@commitlint/cli": "^17.6.6",
        "@commitlint/config-conventional": "^17.6.6",
        "@storybook/addon-essentials": "7.2.3",
        "@storybook/addon-interactions": "7.2.3",
        "@storybook/addon-links": "7.2.3",
        "@storybook/blocks": "7.2.3",
        "@storybook/manager-api": "7.2.3",
        "@storybook/react": "7.2.3",
        "@storybook/react-vite": "7.2.3",
        "@storybook/testing-library": "^0.2.0",
        "@storybook/theming": "7.2.3",
        "@testing-library/jest-dom": "^5.16.5",
        "@testing-library/react": "^14.0.0",
        "@testing-library/user-event": "^14.4.3",
        "@types/jest": "^29.5.3",
        "@types/node": "^20.4.8",
        "@types/react": "^18.0.37",
        "@types/react-dom": "^18.0.11",
        "@typescript-eslint/eslint-plugin": "^5.59.0",
        "@typescript-eslint/parser": "^5.59.0",
        "@vitejs/plugin-react": "^4.0.0",
        "eslint": "^8.38.0",
        "eslint-config-prettier": "^8.8.0",
        "eslint-plugin-react-hooks": "^4.6.0",
        "eslint-plugin-react-refresh": "^0.3.4",
        "eslint-plugin-storybook": "^0.6.13",
        "husky": "^8.0.3",
        "identity-obj-proxy": "^3.0.0",
        "jest": "^29.6.1",
        "jest-environment-jsdom": "^29.6.1",
        "lint-staged": "^13.2.3",
        "prettier": "^3.0.0",
        "prop-types": "^15.8.1",
        "sass": "^1.63.6",
        "standard-version": "^9.5.0",
        "storybook": "7.2.3",
        "stylelint": "^14.16.1",
        "stylelint-config-prettier": "^9.0.5",
        "stylelint-config-sass-guidelines": "^9.0.1",
        "ts-node": "^10.9.1",
        "typescript": "^5.0.2",
        "vite": "^4.3.9",
        "vite-plugin-dts": "^3.3.1"
    }
}
